import { render, staticRenderFns } from "./DataItemReviewsPage.vue?vue&type=template&id=7f352036&scoped=true&"
import script from "./DataItemReviewsPage.vue?vue&type=script&lang=js&"
export * from "./DataItemReviewsPage.vue?vue&type=script&lang=js&"
import style0 from "./DataItemReviewsPage.vue?vue&type=style&index=0&id=7f352036&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f352036",
  null
  
)

export default component.exports